import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, ThemeProvider, Typography } from '@mui/material';

import { passengerThemeV2 } from '@mopla/mui';
import { DTicketPageLayout } from '@mopla/ui';

import { usePassengerAppNavigate } from '../../../hooks';

import { EmptyState, OperatorCard } from './components';
import { useOperators } from './hooks';
import { TicketshopLoading } from './TicketshopLoading';
import { IOperator } from './types';

export const Ticketshop = () => {
	const { t } = useTranslation('ticketshop');
	const { navigateBack, navigateToHome, navigateToOperatorTicketsWithName } =
		usePassengerAppNavigate();
	const { operators, isLoading } = useOperators();

	const handleBack = useCallback(
		() => navigateBack(() => navigateToHome({ replace: true })),
		[navigateBack, navigateToHome]
	);

	const handleOperatorClick = useCallback(
		(operator: IOperator) => {
			navigateToOperatorTicketsWithName(operator.id, operator.name);
		},
		[navigateToOperatorTicketsWithName]
	);

	if (isLoading) {
		return <TicketshopLoading onBack={handleBack} />;
	}

	return (
		<ThemeProvider theme={passengerThemeV2}>
			<DTicketPageLayout
				title={t('page_title')}
				onBack={handleBack}
				scrollable
				dataTestId="ticketshop-page"
			>
				{operators.length === 0 ? (
					<EmptyState />
				) : (
					<Stack gap={2}>
						{operators.map((operator) => (
							<OperatorCard
								key={operator.id}
								operator={operator}
								onClick={handleOperatorClick}
							/>
						))}
					</Stack>
				)}

				<Typography
					variant="b1-m"
					color="solutions.600"
					align="center"
					sx={{ mt: 4 }}
				>
					{t('region_coming_soon')}
				</Typography>
			</DTicketPageLayout>
		</ThemeProvider>
	);
};
